define('common/model/Cash',['knockout', 'underscore'], function(ko, _) {

    var iso4217CurrencyCodeToSymbol = {
        'EUR': '\u20AC' /* € */,
        'GBP': '\u00A3' /* £ */
    };

    function Cash(amount, iso4217CurrencyCode) {
        var self = this;

        self.amount = ko.observable(amount || 0).extend({fixedPointNumber: 4});

        self.normalizedAmount = ko.pureComputed(function() {
            return Math.abs(self.amount());
        }).extend({ fixedPointNumber: 2 });

        self.iso4217CurrencyCode = ko.observable(iso4217CurrencyCode || 'EUR');

        self.currencySymbol = ko.pureComputed(function() {
            var currencyCode = self.iso4217CurrencyCode();
            if (_.str.isBlank(currencyCode)) {
                return '?';
            }
            return iso4217CurrencyCodeToSymbol[currencyCode.toUpperCase()] || '?';
        });
    }

    Cash.getCurrencySymbol = function(iso4217CurrencyCode) {
        return iso4217CurrencyCodeToSymbol[iso4217CurrencyCode];
    };

    return Cash;
});

